<ftr-composable-dropdown [renderMode]="renderType">
  <ftr-composable-dropdown-header>
    <div class="input input--text input--prefix search">
      <input
        #search
        [id]="searchInputId"
        [ngModel]="''"
        (ngModelChange)="list.filter.next($event)"
        [ngClass]="{ 'input__control--has-value': !!search.value }"
        class="input__control search__prefix"
        type="input"
        [attr.placeholder]="''"
      />

      <span class="input__prefix">
        <ftr-icon icon="Search"></ftr-icon>
      </span>

      <label class="input__label" [for]="searchInputId">{{ searchPlaceholder }}</label>
    </div>
  </ftr-composable-dropdown-header>

  <ftr-composable-dropdown-body>
    <div class="checkbox-tree-dropdown__body">
      <ftr-checkbox-tree [items]="items" (childValueChange)="childValueChange.emit($event)" [pluralNoun]="pluralNoun">
      </ftr-checkbox-tree>
    </div>
  </ftr-composable-dropdown-body>
</ftr-composable-dropdown>
